var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(0 && _vm.field.name=='stat')?_c('pre',[_vm._v("        "+_vm._s(_vm.field)+"\n")]):_vm._e(),_c('errors',{attrs:{"errors":_vm.errors}}),(_vm.ready)?_c(_vm.object,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }